import React, { useContext } from 'react'
import { Row, Col } from '@paypalcorp/pp-react'
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react'
import { formatMessage } from '../../../utils/localization/format_worldready'
import { GROUP_STATUS } from '../../../constants'
import { CurrentAmount } from './TotalAmount'
import { ContributeAsGuestButtons } from './ContributeAsGuestButtons'
import { AmountProgress } from './AmountProgress'
import { ContributeAsUserButtons } from './ContributeAsUserButtons'
import { ClosingDate } from './ClosingDate'

interface FlatProgressProps {
  isSmallerScreen: boolean
  isPayPalUser: boolean
  targetAmount?: {
    value: string
    currencyCode: string
  }
  currentAmount?: {
    value: string
    currencyCode: string
  }
  collectedAmount?: {
    value: string
    currencyCode: string
  }
  formattedCollectedAmount: string
  formattedCurrentAmount: string
  formattedTargetAmount: string
  closingDate?: string
  isAdmin?: boolean
  groupStatus?: string
  transferUrl?: string
  handleContributeAsUser: () => void
  handleContributeAsGuest: () => void
  groupId: string
}

const FlatProgress: React.FC<FlatProgressProps> = (props) => {
  const {
    isSmallerScreen,
    isPayPalUser,
    targetAmount,
    currentAmount,
    collectedAmount,
    formattedCollectedAmount,
    formattedCurrentAmount,
    formattedTargetAmount,
    closingDate,
    isAdmin,
    groupStatus,
    transferUrl,
    handleContributeAsUser,
    handleContributeAsGuest,
    groupId,
  } = props

  const worldReadyC = useContext(WorldReadyContext)

  const isActiveGroup = groupStatus === GROUP_STATUS.ACTIVE

  const hasFunds = Number(currentAmount.value) > 0

  const formattedTargetAmountMessage: string = formatMessage({
    worldReady: worldReadyC,
    contentId: `flatProgress.receivedOf`,
    formatOptions: { amount: formattedTargetAmount },
  })

  const formattedClosingDate: string = formatMessage({
    worldReady: worldReadyC,
    contentId: 'flatProgress.acceptingContributionsUntil',
    formatOptions: { closing_date: closingDate },
  })

  return (
    <>
      <Row>
        <Col xs={12}>
          <CurrentAmount
            isSmallerScreen={isSmallerScreen}
            formattedCurrentAmount={formattedCurrentAmount}
            isAdmin={isAdmin}
            hasFunds={hasFunds}
            transferUrl={transferUrl}
          />
          <AmountProgress
            targetAmount={targetAmount}
            isSmallerScreen={isSmallerScreen}
            collectedAmount={collectedAmount}
            formattedCollectedAmount={formattedCollectedAmount}
            formattedTargetAmount={formattedTargetAmountMessage}
            formattedCurrentAmount={formattedCurrentAmount}
          />
          <ClosingDate
            isSmallerScreen={isSmallerScreen}
            formattedClosingDate={formattedClosingDate}
          />
        </Col>
      </Row>

      {isPayPalUser ? (
        <ContributeAsUserButtons
          isAdmin={isAdmin}
          isSmallerScreen={isSmallerScreen}
          hasFunds={hasFunds}
          isActiveGroup={isActiveGroup}
          transferUrl={transferUrl}
          handleContributeAsUser={handleContributeAsUser}
          groupId={groupId}
        />
      ) : (
        <ContributeAsGuestButtons
          isSmallerScreen={isSmallerScreen}
          isActiveGroup={isActiveGroup}
          handleContributeAsGuest={handleContributeAsGuest}
          handleContributeAsUser={handleContributeAsUser}
          groupId={groupId}
        />
      )}
    </>
  )
}

export default FlatProgress
